// Employment page copy, supplied verbatim by the client.

export const jobsPage = {
  hero: {
    eyebrow: "Looking for no experience/night work in Melbourne?",
    title: "Your Next Chapter Starts Here: High-Earning Adult Work in Melbourne",
    intro:
      "Imagine a career where your hard work directly translates into serious money, where you choose your hours, and where you're supported by a professional and friendly team. That's exactly what we offer in our prestigious Melbourne establishment. We are actively seeking motivated women to join us in the thriving, legal world of adult work in Victoria.",
    bandKicker: "Legal clubs and establishments",
    bandHeadline: "Earn from $3,000-$6,000 per week",
    bandText:
      "Melbourne is a city of ambition and opportunity, and your financial goals should match that energy. With us, you have the potential to earn outstanding money, providing you with the financial freedom to pursue your studies, travel the world, or simply build the life you've always wanted. Forget the daily grind and step into an environment where you are valued and generously rewarded. Apply for a job at a designer brand brothel today!",
  },

  sections: [
    {
      id: "elite-team",
      title: "The Best Brothel Jobs in Melbourne: Join Our Elite Team",
      kicker:
        "High-paying jobs available - no experience needed. Apply now for an interview.",
      paragraphs: [
        "If you've been searching for a supportive, safe, and sophisticated entry into brothel jobs in Melbourne, your search ends here. We pride ourselves on operating a premium, legal establishment where professionalism and discretion are paramount. We believe in investing in our team, which is why you don't need previous experience to become a part of our establishment. We provide everything you need to succeed.",
      ],
      cards: [],
    },
    {
      id: "look-and-feel",
      title: "Look and Feel Your Absolute Best",
      paragraphs: [
        "We understand that confidence is key to success in the adult work industry. Therefore, our focus is on ensuring you look and feel sensational every time you step through our doors.",
      ],
      cards: [
        {
          icon: "Sparkles",
          title: "The Glamour Package",
          text: "You'll receive generous perks to help you maintain your beautiful appearance, including financial support for clothing, hair, makeup, and beauty. Looking incredible isn't a chore, but a part of the exceptional experience we cultivate for both you and our clientele.",
        },
        {
          icon: "Users",
          title: "The A-Team on Tap",
          text: "Need professional advice or a quick confidence boost? Our in-house hairstylist, makeup artist, and personal trainer are available by appointment. Whether it's perfecting a look or getting tailored fitness and nutrition advice, we're here to help you bring your absolute best self to work.",
        },
        {
          icon: "HeartHandshake",
          title: "New to Brothel Employment? We've Got Your Back",
          text: "Starting any new adult work can be a learning curve, but if you're new to the scene, don't worry. We offer comprehensive, free support that includes everything from makeup application and fitness tips to managing your diet, nutrition, savings, and even helping you pick out the perfect, client-ready outfits and shoes.",
        },
      ],
    },
    {
      id: "travel-support",
      title: "Stress-Free Travel and Accommodation Support",
      paragraphs: [
        "If you're ready to relocate for one of the best-paying brothel jobs in Victoria, we make the transition easy.",
      ],
      cards: [
        {
          icon: "Plane",
          title: "Flying In? No Stress",
          text: "Whether you're coming from interstate or just outside the greater Melbourne area, we'll cover your flights and reimburse your travel expenses.",
        },
        {
          icon: "BedDouble",
          title: "Comfort is Key",
          text: "We'll even sort out comfy, secure off-site accommodation so you can focus on your new, high-earning career without the stress of finding a place to stay. Easy as!",
        },
      ],
    },
    {
      id: "your-rules",
      title: "Your Career, Your Rules: Flexibility in Adult Work",
      kicker:
        "There's an opening to join our prestigious establishment, offering one of the best brothel jobs in Melbourne.",
      paragraphs: [
        "We offer an unparalleled opportunity to enjoy life on your own terms. In the legal and regulated environment of Victoria, we empower you with genuine flexibility.",
      ],
      cards: [
        {
          icon: "Clock",
          title: "Set Your Own Hours",
          text: "You have the freedom to choose your schedule, making this an ideal career for managing studies, family life, or personal projects. This is your opportunity to earn a great income on a flexible schedule.",
        },
        {
          icon: "ShieldCheck",
          title: "A Safe & Classy Space",
          text: "Your security is our number one priority. Our establishment is fully licensed and compliant, offering a secure, high-end environment. Our experienced and friendly management team is always on hand, offering training, advice, and support to ensure your successful and high-paying career in adult work.",
        },
        {
          icon: "Target",
          title: "Meet Your Goals",
          text: "We are looking for motivated individuals between the ages of 18 and 35 who are focused on achieving their personal and financial goals.",
        },
      ],
      listTitle: "You could be a:",
      list: [
        "A dancer looking for a more financially rewarding path in the adult work industry",
        "Traveller or backpacker funding an extended stay or adventure across Australia.",
        "A student working flexible hours to pay off fees and secure their future.",
        "Single mum needing a significant, reliable income to get ahead in life.",
        "Motivated woman ready to make a significant positive change to your financial status.",
      ],
      outro:
        "Our culture is one of mutual respect and high professionalism. We let you enjoy life on your own terms, set your own hours, and meet new people in a truly safe and classy setting. If you are a woman with a drive and a positive outlook, we want to hear from you!",
    },
  ],

  enquiry: {
    id: "confidential-enquiry",
    title: "Take the First Step: Confidential Enquiry Today",
    kicker: "Interested? - Find Out More Today (Confidentiality Assured)",
    paragraphs: [
      "We understand that applying for brothel employment is a highly personal decision. Your privacy and confidentiality are guaranteed from your very first contact with us. If you're not quite sure what to expect or you have some questions about the work, environment, or the application process, please reach out. We are happy to answer your questions honestly and discreetly.",
    ],
    smsLabel: "SMS Lisa",
    smsNumber: "0429 085683",
    smsNote: "No direct telephone calls",
    outro:
      "We are glad to answer your questions in complete confidence and help you determine if a career in Melbourne adult work is the right path for you. Apply for your brothel job today!",
  },

  important: {
    id: "application-information",
    title: "Important Application Information",
    items: [
      {
        title: "Interstate Applicants",
        text: "If you are currently living interstate and are serious about joining our Melbourne team, we will gladly cover your airfares to join us for an interview after we have spoken on the telephone. This commitment demonstrates our dedication to finding the right women for these rewarding positions.",
      },
      {
        title: "Quick Start",
        text: "Once you have been successfully interviewed and onboarded, you may be invited to start as soon as possible, allowing you to begin achieving your financial goals without delay.",
      },
    ],
    outro:
      "We look forward to hearing from you and welcoming you to our prestigious Melbourne establishment. Take the leap! Your high-paying new career awaits right here at our highly established brothels!",
  },
};

export default jobsPage;
